import { render, staticRenderFns } from "./VideoSelector.vue?vue&type=template&id=7e5e5792&scoped=true&"
import script from "./VideoSelector.vue?vue&type=script&lang=ts&"
export * from "./VideoSelector.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSelector.vue?vue&type=style&index=0&id=7e5e5792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5e5792",
  null
  
)

export default component.exports